import API from "../../Api/Api.js";
import { closeModal } from "./confirmationModal.js";
import { handleError, handleInfo } from "./notifications.js";
import qs from "qs";
import _ from "lodash";
const token = localStorage.getItem("token");

const articleItemQuery = (id) =>
  qs.stringify(
    {
      filters: { id: { $eq: id } },
      populate: {
        banner: {
          populate: "*",
        },
        sections: {
          populate: "*",
          sort: ["order:asc"],
        },
        authorImage: {
          populate: "*",
        },
        seo: {
          populate: "ogimage",
        },
      },
    },
    { encodeValuesOnly: true }
  );

export const getAllArticles = (filter) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  const query = qs.stringify(
    {
      filters: {
        title: {
          $containsi: filter,
        },
      },
      populate: {
        banner: {
          populate: "*",
        },
      },
      sort: ["createdAt:desc"],
    },

    {
      encodeValuesOnly: true,
    }
  );
  dispatch({ type: "ARTICLE_LOADING" });
  try {
    let { data } = await API.get("api/articles?" + query);
    dispatch({ type: "FETCH_ARTICLES", payload: data.data });
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const deletArticle = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  API.defaults.params = {};
  dispatch({ type: "ARTICLE_LOADING" });
  try {
    await API.delete(`api/articles/${id}`);
    dispatch(getAllArticles());
    dispatch(closeModal());
    dispatch(handleInfo("Article deleted", 1));
  } catch (error) {
    dispatch(handleError("Error while deleting the article", 1));
    console.log(error);
  }
};

export const publishOrNoPublishArticle =
  (id, published) => async (dispatch) => {
    API.defaults.headers.common["Authorization"] = token;
    dispatch({ type: "ARTICLE_LOADING" });
    try {
      await API.put(`api/articles/${id}`, { data: { publish: published } });
      dispatch(getArticleItem(id));
      dispatch(getAllArticles());
      dispatch(closeModal());
      dispatch(handleInfo(published ? "Article published" : "Article unpublished", 1));
    } catch (error) {
      dispatch(handleError("Error while publishing the article", 1));
      console.log(error);
    }
  };

export const addArticle = () => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  API.defaults.params = {};
  let defaultImage = null;

  dispatch({ type: "ARTICLE_LOADING" });
  try {
    let image = await API.get("api/upload/files");
    defaultImage = image.data[0].id;
  } catch (error) {
    dispatch(handleError("Network error", 1));

    console.log(error);
  }

  try {
    if (!defaultImage) {
      return dispatch(
        handleError("Please import at least one image to proceed", 1)
      );
    }
    const defaultBanner = {
      title: "default banner",
      subtitle: "default subtitle",
      image: [defaultImage],
    };

    let defaultArticleFR = {
      publish: false,
      title: "default article title",
      subtitle: "default article subtitle",
      author: "default author",
      authorImage: defaultImage,
      description: "default description",
    };

    let defaultSEOFR = {
      title: "default article SEO title",
      description: "default article SEO description",
      ogimage: defaultImage,
    };

    let SEOfr = await API.post("/api/seos", {
      data: defaultSEOFR,
    });

    let bannerfr = await API.post("/api/sections", {
      data: defaultBanner,
    });

    await API.post("/api/articles", {
      data: {
        banner: bannerfr.data.data.id,
        seo: SEOfr.data.data.id,
        ...defaultArticleFR,
      },
    });

    dispatch(handleInfo("Article created", 1));
    dispatch(getAllArticles());
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const getArticleItem = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  dispatch({ type: "ARTICLE_LOADING" });
  try {
    let { data } = await API.get("/api/articles?" + articleItemQuery(id));

    dispatch({ type: "FETCH_ARTICLE_ITEM", payload: data.data[0] });
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const updateArticle = (id, article) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  dispatch({ type: "ARTICLE_LOADING" });
  try {
    await API.put(`/api/articles/${id}`, { data: article });

    dispatch(handleInfo("Article modified", 1));
    dispatch(getArticleItem(id));
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

// Strapi v4 media: { data: { id } } | { data: [{ id }] } | { data: null }
const mediaIds = (media) =>
  Array.isArray(media?.data)
    ? media.data.map((file) => file.id)
    : media?.data?.id ?? null;

const SECTION_FIELDS = [
  "name",
  "order",
  "title",
  "subtitle",
  "description",
  "content",
  "buttonText",
  "buttonUrl",
  "regularTitle",
  "decoratedTitle",
  "limitedCarousel",
  "showButton",
  "resolution",
];
const SECTION_MEDIA = ["image", "image2", "imageMobile", "imageMobile2", "carousel"];

const copySection = async (section) => {
  const attributes = section.attributes;
  const { data } = await API.post("/api/sections", {
    data: {
      ..._.pick(attributes, SECTION_FIELDS),
      ...Object.fromEntries(
        SECTION_MEDIA.map((key) => [key, mediaIds(attributes[key])])
      ),
    },
  });
  return data.data.id;
};

// Copies an article (banner, sections with their gallery, SEO) as a new unpublished article.
export const duplicateArticle = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  API.defaults.params = {};
  dispatch({ type: "ARTICLE_LOADING" });
  try {
    const { data } = await API.get("/api/articles?" + articleItemQuery(id));
    const article = data.data[0].attributes;
    const seo = article.seo?.data?.attributes;

    const [bannerId, sectionIds, newSeo] = await Promise.all([
      article.banner?.data ? copySection(article.banner.data) : null,
      Promise.all((article.sections?.data || []).map(copySection)),
      seo
        ? API.post("/api/seos", {
            data: {
              title: `Copy of ${seo.title}`,
              description: seo.description,
              ogimage: mediaIds(seo.ogimage),
            },
          })
        : null,
    ]);

    await API.post("/api/articles", {
      data: {
        ..._.pick(article, ["subtitle", "description", "author", "authorTitle", "type"]),
        title: `Copy of ${article.title}`,
        publish: false,
        authorImage: mediaIds(article.authorImage),
        banner: bannerId,
        sections: sectionIds,
        seo: newSeo?.data?.data?.id ?? null,
      },
    });

    dispatch(closeModal());
    dispatch(handleInfo("Article duplicated", 1));
    dispatch(getAllArticles());
  } catch (error) {
    dispatch(closeModal());
    dispatch(handleError("Error while duplicating the article", 1));
    dispatch(getAllArticles());
    console.log(error);
  }
};
